
export enum SessionDetailView {
  EMBEDDED = 'embedded',
  COACHING = 'coaching',
  MAIN = 'main',
  MINIMAL = 'minimal'
}

export function viewCanSeeHeader(view: SessionDetailView) {
  return view !== SessionDetailView.EMBEDDED
}

export function viewCanSeeComments(view: SessionDetailView) {
  return view === SessionDetailView.MAIN
}

export function viewCanSeeAllAutomations(view: SessionDetailView) {
  return [SessionDetailView.MAIN, SessionDetailView.MINIMAL].includes(view)
}

export function viewCanSeePastCalls(view: SessionDetailView) {
    return view === SessionDetailView.MAIN
}

export function viewHasMinimalHeader(view: SessionDetailView) {
  return [SessionDetailView.COACHING, SessionDetailView.EMBEDDED].includes(view)
}

export function viewEnforcesStart(view: SessionDetailView) {
  return ![SessionDetailView.COACHING, SessionDetailView.EMBEDDED, SessionDetailView.MAIN].includes(view)
}